import styled from "styled-components";

export const ServicesSection = styled.section`
  padding: 0 80px 80px;

  @media (max-width: 768px) {
    padding: 0 24px 48px;
  }
`;

export const ServicesHeader = styled.div`
  text-align: center;
  margin-bottom: 64px;

  h2 {
  margin-bottom: 12px;
  }

  @media (max-width: 768px) {
    margin-bottom: 48px;
  }
`;

export const CenteredTitle = styled.h2`
  font-family: 'Playfair Display', serif;
  font-size: 42px;
  font-weight: 400;
  line-height: 1.2;
  color: #111;
  max-width: 800px;
  margin: 0 auto;
  
  @media (max-width: 768px) {
    font-size: 32px;
    line-height: 1.1;
  }
  
  @media (max-width: 480px) {
    font-size: 28px;
  }
`;

export const ServicesContent = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 64px;
  align-items: center;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 48px;
  }
`;

export const ServicesImage = styled.div`
  position: relative;
  border-radius: 16px;
  overflow: hidden;

  img {
    width: 100%;
    height: 500px;
    display: block;
    object-fit: cover; 
    transition: transform 0.5s ease;
  }

  @media (max-width: 768px) {
    img {
      width: 100%;
      height: 350px;
      display: block;
      transition: transform 0.5s ease;
    }
  }
`;